import React, { useEffect, useState } from "react";
import {
  Button,
  Input,
  Form,
  Row,
  Col,
  Spin,
} from "antd";
import { useStore } from "../../../../../../store";
import { contactUSkeys } from "../../../../../../config";
import { useTab } from "../../../../../../custom-hooks/useTab";
import watsapp from "../../../../../../assets/images/watsapp.svg";
import phoneIc from "../../../../../../assets/images/phone.svg";
import Website from "../../../../../../assets/images/website.svg";
import mail from "../../../../../../assets/images/mail.svg";
import PhoneInput from "react-phone-number-input";

const { TextArea } = Input;

export default function Sales({ dataLoader, form, tabKey }) {
  const { tabData, skills } = useStore();
  const whichTab = contactUSkeys.sales;
  const { postLoader } = useTab();
  const [formChanged, setFormChanged] = useState(false);
  const { updatedValues } = useStore();

  useEffect(() => {
    const isNotEmpty = Object.keys(updatedValues).length > 0;

    setFormChanged(isNotEmpty);
  }, [Object.keys(updatedValues).length]);

  const onChange = () => {
    setFormChanged(true);
  };

  if (dataLoader || postLoader) {
    return (
      <div className="data-loader">
        <Spin tip="Loading" size="large" />
      </div>
    );
  } else {
    return (
      <div>
        {/* <Form name={tabKey}> */}
        <Row className="rowBody" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          {tabKey === contactUSkeys.sales ? (
            <>
              <Col className="gutter-row tabContent" span={15}>
                <Form.List
                  name={contactUSkeys.sales}
                  initialValue={
                    tabData && tabData[tabKey] && tabData[tabKey].length > 0
                      ? tabData[tabKey]
                      : [""]
                  }
                >
                  {(fields) => (
                    <div>
                      {fields.map(({ key, name, ...restField }, i) => (
                        <>
                          <Form.Item
                            {...restField}
                            label={
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <div style={{ minWidth: "24px" }}>
                                  <img
                                    src={phoneIc}
                                    alt="Phone"
                                    style={{ marginRight: "3px" }}
                                  />
                                </div>
                                Phone
                              </div>
                            }
                            labelCol={{ span: 4 }}
                            name={[name, "phone"]}
                            rules={[
                              {
                                required: true,
                                message: "Please enter phone number.",
                              },
                            ]}
                          >
                            <PhoneInput
                              className="custom-phone-input"
                              defaultCountry="GB"
                              placeholder="Enter phone number"
                              focusInputOnCountrySelection
                            />
                          </Form.Item>
                          <Form.Item
                            label={
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <div style={{ minWidth: "24px" }}>
                                  <img
                                    src={mail}
                                    alt="Image"
                                    style={{ marginRight: "3px" }}
                                  />
                                </div>
                                Email
                              </div>
                            }
                            labelCol={{ span: 4 }}
                            {...restField}
                            name={[name, "email"]}
                            rules={[
                              { required: true, message: "Email is required" },
                              { type: "email", message: "Enter a valid email" },
                            ]}
                          >
                            <Input placeholder="Enter Email" />
                          </Form.Item>
                          <Form.Item
                            label={
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <div style={{ minWidth: "24px" }}>
                                  <img
                                    src={watsapp}
                                    alt="Image"
                                    style={{ marginRight: "3px" }}
                                  />
                                </div>
                                Whatsapp
                              </div>
                            }
                            labelCol={{ span: 4 }}
                            rules={[
                              { required: false },
                              {
                                pattern: /^\d{10}$/,
                                message: "Enter a valid 10-digit phone number",
                              },
                            ]}
                            {...restField}
                            name={[name, "chatNumber"]}
                          >
                            <Input
                              type="tel"
                              maxLength={10}
                              onKeyPress={(e) => {
                                if (!/[0-9]/.test(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                              placeholder="Enter Whatsapp Number"
                            />
                          </Form.Item>
                          <Form.Item
                            label={
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <div style={{ minWidth: "24px" }}>
                                  <img
                                    src={Website}
                                    alt="Image"
                                    style={{ marginRight: "3px" }}
                                  />
                                </div>
                                Website
                              </div>
                            }
                            labelCol={{ span: 4 }}
                            {...restField}
                            name={[name, "websiteLink"]}
                            rules={[
                              { required: true, message: "Link is required" },
                              { type: "url", message: "Enter a valid URL" },
                            ]}
                          >
                            <Input placeholder="Enter Website Link" />
                          </Form.Item>
                          {/* <Form.Item
                          label={
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                              <img src={address} alt="Image"style={{ marginRight: '3px' }} />
                              Address
                            </div>
                          }
                            labelCol={{ span: 4 }}
                            {...restField}
                            name={[name, "postalAddress"]}
                            rules={[
                              {
                                required: true,
                                message: "Address is required",
                              },
                            ]}
                          >
                            <TextArea placeholder="Enter Address" rows={5} />
                          </Form.Item> */}
                          <Form.Item
                            className="w-100"
                            style={{
                              display: "flex",
                              justifyContent: "end",
                            }}
                          >
                            {formChanged ? (
                              <Button
                                className="saveBtn greenBtn"
                                onClick={() => {
                                  form
                                    .submit()
                                    .then(() => {
                                      setFormChanged(false);
                                    })
                                    .catch((errorInfo) => {
                                      console.error(
                                        "Form submission failed:",
                                        errorInfo
                                      );
                                    });
                                }}
                              >
                                Save
                              </Button>
                            ) : (
                              <Button
                                className="saveBtn greenBtn"
                                style={{
                                  opacity: "0.5",
                                  pointerEvents: "none",
                                }}
                              >
                                Save
                              </Button>
                            )}
                          </Form.Item>
                        </>
                      ))}
                    </div>
                  )}
                </Form.List>
              </Col>
            </>
          ) : (
            <></>
          )}
        </Row>
        {/* </Form> */}
      </div>
    );
  }
}
